<template>
  <v-container>
    <v-card flat>
      <v-card-title primary-title class="justify-center headline">
        {{ vraag }}
        <v-btn
          icon
          title="Herhaal vraag"
          class="ml-3"
          @click="spreekvraag()"
          v-show="this.autonext == null"
          ><v-icon large>mdi-bullhorn-outline</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text class="text-center">
        <v-img
          :src="'/images/VraagImg/' + image"
          alt="Afbeelding bij vraag"
          v-show="image && image != ''"
          max-width="1000"
          class="mx-auto"
        ></v-img>
        <v-img
          :src="dbimage"
          alt="Afbeelding bij vraag"
          v-show="dbimage"
          max-width="1000"
          class="mx-auto"
          lazy-src="/images/VraagImg/loading.jpg"
        ></v-img>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn icon x-large v-show="this.autonext == null"
          ><v-icon x-large></v-icon
        ></v-btn>
        <v-btn
          v-if="antwoordtype == 'janee'"
          @click="nee()"
          color="red"
          min-height="120"
          min-width="120"
          class="mx-10 headline"
          >Nee</v-btn
        >
        <v-btn
          v-if="antwoordtype == 'janee'"
          @click="ja()"
          color="green"
          min-height="120"
          min-width="120"
          class="mx-10 headline"
          >Ja</v-btn
        >
        <v-btn
          v-if="antwoordtype == 'smiley'"
          @click="s4()"
          color="red"
          min-height="120"
          min-width="120"
          class="mx-10"
          ><v-img src="/images/sad-black.png" max-width="100" title=":("></v-img
        ></v-btn>
        <v-btn
          v-if="antwoordtype == 'smiley'"
          @click="s2()"
          color="yellow"
          min-height="120"
          min-width="120"
          class="mx-10"
          ><v-img
            src="/images/neutral-black.png"
            max-width="100"
            title=":|"
          ></v-img
        ></v-btn>
        <v-btn
          v-if="antwoordtype == 'smiley'"
          @click="s1()"
          color="green"
          min-height="120"
          min-width="120"
          class="mx-10"
          ><v-img
            src="/images/happy-black.png"
            max-width="100"
            title=":)"
          ></v-img
        ></v-btn>

        <v-btn
          icon
          x-large
          title="Vraag overslaan"
          @click="slaover()"
          v-show="this.autonext == null"
          ><v-icon color="primary" x-large>mdi-skip-forward</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Vraag",
  props: [
    "vraag",
    "image",
    "antwoordtype",
    "audio",
    "autonext",
    "vraagid",
    "userid",
    "vraagaanwezig",
    "afbeeldingcode",
  ],
  data() {
    return {
      timer: null,
      ConsoleNaam: "Web-001",
      dbimage: null,
    };
  },
  methods: {
    ja: function () {
      this.$emit("antwoord", "ja");
    },
    nee: function () {
      this.$emit("antwoord", "nee");
    },
    s1: function () {
      this.$emit("antwoord", "s1");
    },
    s2: function () {
      this.$emit("antwoord", "s2");
    },
    //s3: function() {
    //  this.$emit('antwoord', 's3');
    //},
    s4: function () {
      this.$emit("antwoord", "s4");
    },
    slaover: function () {
      this.$emit("antwoord", "slaover");
    },
    spreekvraag: function () {
      if (this.audio && this.audio != "") {
        var audio = new Audio("/audio/" + this.audio);
        audio.play();
      }
    },
  },
  watch: {
    vraag: function () {
      // Spreek vraag uit bij verandering van vraag.
      this.spreekvraag();
    },
    autonext: function () {
      // Automatisch naar volgende vraag na X seconde.
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.autonext) {
        var self = this;
        this.timer = setTimeout(function () {
          self.slaover();
        }, this.autonext * 1000);
      }
    },
    afbeeldingcode: function () {
      if (this.afbeeldingcode) {
        this.dbimage = null;
        this.$api
          .pMedewerkerFotoGet({ Code: this.afbeeldingcode })
          .then((response) => {
            if (response.data.length > 0) this.dbimage = response.data[0].Foto;
          });
      } else {
        this.dbimage = null;
      }
    },
  },
  created: function () {
    var self = this;
    // Timer voor uitspreken 1e vraag.
    setTimeout(function () {
      self.spreekvraag();
    }, 2000);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
